import { StringUtility } from 'utility-ts-type';
import { SettingsCapabilityConfiguration } from '../../settings_configuration';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { PronounsQuery } from 'capability-ng-priority-feed';

export class SettingsWelcomeController {
  public model: {
    userFullName: string;
    userInitials: string;
    userStudentNK: string;
    userEmail: string;
    imageUrl: string;
    userPronouns: string;
  };
  private flags: {
    hasUserEmail: boolean;
    showStudentCard: boolean;
    showPronouns: boolean;
  };

  constructor(
    private ngSettingsCapabilityConfiguration: SettingsCapabilityConfiguration,
    private accountModel: AccountModel,
    private ngPronounsQuery: PronounsQuery
  ) {
    this.model = {
      userFullName: this.accountModel.fullname,
      userInitials: StringUtility.getAcronym(...this.accountModel.fullname.split(' ')),
      userStudentNK: this.accountModel.student_nk,
      userEmail: this.accountModel.email,
      imageUrl: this.ngSettingsCapabilityConfiguration.config.institutionMediaPath,
      userPronouns: _4.get(this.ngPronounsQuery.result, 'selected_pronouns')
    };

    this.flags = {
      showStudentCard: this.ngSettingsCapabilityConfiguration.config.isStudentNKCardEnabled,
      hasUserEmail: !_4.isEmpty(this.model.userEmail),
      showPronouns: !_4.isEmpty(this.model.userPronouns)
    };
  }

  universityLogo(): Record<string, string> {
    return {
      'background-image': `url('${this.model.imageUrl}')`
    };
  }

  hasUniversityLogo(): boolean {
    return !_.isEmpty(this.model.imageUrl);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/components/settings_welcome/settings_welcome_controller.ts